<template>
  <div class="flex items-center gap-3" :class="wrapperClass">
    <div class="w-10 h-10 rounded-full bg-primary-purple-100 flex items-center justify-center">
      <icon class="w-5 h-5" icon="user" />
    </div>
    <div class="flex-1">
      <div class="font-semibold text-primary-gray-900">
        {{ capitalizeWords(author?.name || author) }}
      </div>
      <div v-if="time" class="text-primary-gray-500 text-xs">
        {{ time }}
      </div>
    </div>
  </div>
</template>

<script>
import icon from '@components/icons/icon.vue'
import { capitalizeWords } from '@utils/generalUtil'
import DATE_TIME_CONSTANT from '@src/constants/date-time-constants.js'

export default {
  name: 'AuthorCard',
  components: { icon },
  props: {
    author: {
      type: [String, Object],
      required: true,
    },
    time: {
      type: String,
      default: '',
    },
    wrapperClass: {
      type: [String, Object, Array],
      default: 'mb-3',
    },
  },
  data() {
    return {
      DATE_TIME_CONSTANT,
    }
  },
  methods: {
    capitalizeWords,
  },
}
</script>
